export const IMS_PROD_BASE_URL = 'https://cloudfi.tenda.com.cn'
export const IMS_TEST_BASE_URL = 'https://cloudfi.test.tenda.com.cn'
const IMS_LEGACY_PROD_BASE_URL = 'https://ims.ip-com.com.cn'
const IMS_LEGACY_TEST_BASE_URL = 'https://ims.test.ip-com.com.cn'

/**
 * @description APP 下载页地址（掌中宝APP）
 */
export const APP_DOWNLOAD_URL = 'https://cloudfi.tenda.com.cn/download/downloadCloudFiApp.html'

/**
 * @description 掌中宝 APP 下载二维码（站内统一资源）
 */
export const APP_DOWNLOAD_QR_CODE = '/images/footer/APP.png'

/**
 * @description 腾达公众号二维码（页脚等场景）
 */
export const WECHAT_OFFICIAL_ACCOUNT_QR_CODE = '/images/footer/wxgzh.png'

/**
 * @description 腾达视频号二维码（页脚等场景）
 */
// static-asset-consumed-by: withBase (Footer.vue)
export const WECHAT_CHANNELS_QR_CODE = '/images/footer/shipinhao-qr.png'

/**
 * @description 根据运行环境返回 IMS 基础地址
 * @param {string} env - 当前运行环境
 * @returns {string} IMS 基础地址
 */
export const getImsBaseUrlByEnv = (env = 'development') => {
  return env === 'production' ? IMS_PROD_BASE_URL : IMS_TEST_BASE_URL
}

/**
 * @description 判断是否为测试 IMS 域名
 * @param {string} url - 待判断的地址
 * @returns {boolean} 是否为测试 IMS 域名
 */
export const isTestImsUrl = (url = '') => {
  return (
    typeof url === 'string' &&
    (url.includes('cloudfi.test.tenda.com.cn') || url.includes('ims.test.ip-com.com.cn'))
  )
}

/**
 * @description 归一化 IMS 域名，兼容历史 ims.* 域名并统一切换到 cloudfi.*
 * @param {string} url - 原始地址
 * @returns {string} 归一化后的地址
 */
export const normalizeImsUrl = (url = '') => {
  if (typeof url !== 'string' || !url) {
    return ''
  }

  return url
    .replace(IMS_LEGACY_TEST_BASE_URL, IMS_TEST_BASE_URL)
    .replace(IMS_LEGACY_PROD_BASE_URL, IMS_PROD_BASE_URL)
}

/**
 * @description 解析运行时 IMS 基础地址，避免生产环境回退到测试域名
 * @param {Object} publicConfig - runtimeConfig.public
 * @returns {string} 可用的 IMS 基础地址
 */
export const resolveImsBaseUrl = (publicConfig = {}) => {
  const env = publicConfig.env || 'development'
  const fallbackBaseUrl = getImsBaseUrlByEnv(env)
  const configuredBaseUrl = normalizeImsUrl(publicConfig.imsApiBase)

  if (!configuredBaseUrl || typeof configuredBaseUrl !== 'string') {
    return fallbackBaseUrl
  }

  if (env === 'production' && isTestImsUrl(configuredBaseUrl)) {
    return fallbackBaseUrl
  }

  return configuredBaseUrl
}

/**
 * @description 解析运行时登录地址，避免生产环境误跳测试环境
 * @param {Object} publicConfig - runtimeConfig.public
 * @returns {string} 登录地址
 */
export const resolveImsLoginUrl = (publicConfig = {}) => {
  const env = publicConfig.env || 'development'
  const fallbackLoginUrl = `${resolveImsBaseUrl(publicConfig)}/static/lrf/login`
  const configuredLoginUrl = normalizeImsUrl(publicConfig.loginUrl)

  if (!configuredLoginUrl || typeof configuredLoginUrl !== 'string') {
    return fallbackLoginUrl
  }

  if (env === 'production' && isTestImsUrl(configuredLoginUrl)) {
    return fallbackLoginUrl
  }

  return configuredLoginUrl
}

/**
 * @description 解析运行时注册地址，避免生产环境误跳测试环境
 * @param {Object} publicConfig - runtimeConfig.public
 * @returns {string} 注册地址
 */
export const resolveImsRegisterUrl = (publicConfig = {}) => {
  const env = publicConfig.env || 'development'
  const fallbackRegisterUrl = `${resolveImsBaseUrl(publicConfig)}/static/lrf/register`
  const configuredRegisterUrl = normalizeImsUrl(publicConfig.registerUrl)

  if (!configuredRegisterUrl || typeof configuredRegisterUrl !== 'string') {
    return fallbackRegisterUrl
  }

  if (env === 'production' && isTestImsUrl(configuredRegisterUrl)) {
    return fallbackRegisterUrl
  }

  return configuredRegisterUrl
}
